import {
  BulkTearsheetGenerationPayload,
  DownloadTearsheetZipResponse,
  TearSheetsRecord,
  TearSheetsUpload,
} from '../../schemas/BulkTearsheetGeneration.schema';
import { MaggieHttp } from '../MaggieHttp';

type BulkTearsheetGenerationRequest = BulkTearsheetGenerationPayload & { useRendererV2: boolean };

export async function generateTearsheets(payload: BulkTearsheetGenerationRequest): Promise<void> {
  const { data } = await MaggieHttp.maggie.post<BulkTearsheetGenerationRequest, void>(
    '/tearsheets/bulk',
    prepareBulkTearsheetGenerationPayload(payload),
    // Bulk PDF generation legitimately runs longer than the instance default —
    // opt out of the client timeout (0 = no timeout) so it isn't falsely aborted.
    { timeout: 0 }
  );

  return data;
}

export async function downloadBulkTearsheetsAsZip(payload: BulkTearsheetGenerationRequest): Promise<Blob> {
  const { data } = await MaggieHttp.maggie.post<BulkTearsheetGenerationRequest, Blob>(
    '/tearsheets/bulk/download',
    prepareBulkTearsheetGenerationPayload(payload),
    {
      responseType: 'blob',
      // Generates and streams a multi-tearsheet zip — no client timeout.
      timeout: 0,
    }
  );

  return data;
}

export async function getTearSheets(): Promise<TearSheetsUpload[]> {
  const { data } = await MaggieHttp.maggie.get<TearSheetsUpload[]>('/tearsheets/uploads');
  return data;
}

export async function getTearsheetsByUploadId(uploadId: number): Promise<TearSheetsRecord[]> {
  const { data } = await MaggieHttp.maggie.get<TearSheetsRecord[]>(`/tearsheets/uploads/${uploadId}`);
  return data;
}

export async function downloadTearsheetZip(uploadId: number): Promise<DownloadTearsheetZipResponse> {
  const { data } = await MaggieHttp.maggie.post<void, DownloadTearsheetZipResponse>(
    `/tearsheets/uploads/${uploadId}/download-link`
  );
  return data;
}

function prepareBulkTearsheetGenerationPayload(
  payload: BulkTearsheetGenerationRequest
): BulkTearsheetGenerationRequest {
  const { fundIds, ...rest } = payload;
  return {
    ...rest,
    fundIds: fundIds?.length && fundIds.length > 0 ? fundIds : undefined,
  };
}
